export default __webpack_public_path__ + "static/media/feather_user.b076aa2d.svg";